import { sortBy, prop, pipe, reduce, lensProp, append, over, concat } from 'ramda'

const sortByName = sortBy(prop('NameInternal'))

const positionSplitter = reduce(
  (agg, next) => {
    const hasPosition =
      next.Position !== '' && next.Position !== null && next.Position !== undefined
    const lens = hasPosition ? lensProp('withPosition') : lensProp('withoutPosition')
    return over(lens, append(next), agg)
  },
  { withoutPosition: [], withPosition: [] },
)

const sortByPosition = sortBy(prop('Position'))

const sortProducts = pipe(
  sortByName,
  positionSplitter,
  over(lensProp('withPosition'), sortByPosition),
  x => concat(x.withPosition, x.withoutPosition),
)

export default sortProducts
